<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <div class="trial__header">
            <p class="fs-6 mb-0 trial__title">
                {{ $t.__('common.labels.15_days_free_trial_without_obligation') }}
            </p>
            <underline-straight class="block trial__underline mx-auto" />
        </div>
        <p class="trial__baseline">
            {{ $t.__('common.labels.freely_test_all_features') }}
        </p>
        <img
            :src="banner"
            class="mx-auto my-3 trial__img"
            :alt="$t.__('common.labels.freely_test_all_features_alt')"
        />
        <p class="fs-4 mb-3 trial__subtitle mt-0">
            {{ $t.__('common.labels.many_company_use_sellsy_every_day') }}
        </p>
        <customer-logo />
    </div>
</template>

<script>
import UnderlineStraight from 'logged/pricing/underline-straight.svg';
import CustomerLogo from 'logged/onboarding/customer-logo.svg';
export default {
    components: {
        UnderlineStraight,
        CustomerLogo,
    },
    props: {
        lang: {
            type: String,
            required: true,
        },
    },
    computed: {
        banner() {
            return this.lang === 'fr'
                ? '/ressources/logged/img/onboarding/trial-illustration.png'
                : '/ressources/logged/img/onboarding/trial-illustration-en.png';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
.trial__title,
.trial__subtitle,
.trial__baseline {
    font-family: $font-2;
    color: $secondary-blue;
}

.trial__title {
    font-weight: 500;
    line-height: 30px;
}

.trial__subtitle {
    font-weight: 500;
    line-height: 20px;
}

.trial__baseline {
    margin: 22px 0 0;
    font-size: 16px;
    font-weight: $font-weight-light;
    line-height: 24px;
}

.trial__img {
    display: block;
    height: auto;
    max-width: 100%;
}

.trial__header {
    position: relative;
    max-width: 520px;
    margin: 0 auto;
}

.trial__underline {
    position: absolute;
    bottom: -5px;
    left: 196px;
}
</style>
